<template>
  <div style="height: 100%">
    <apex-chart
      :style="`${index > 0 ? 'margin-top: -25px' : ''}`"
      v-for="(chart, index) in charts"
      :key="`chart_${index}`"
      :ref="`chart`"
      height="100%"
      :options="options"
      :series="chart.series"
      :resizeChecking="false"
    >
      <template>
        <p
          style="position: absolute; text-align: center; width: 100%; top: 10px"
        >
          {{ chart.depthLabel }}
        </p>
      </template>
    </apex-chart>
  </div>
</template>

<script>
import apexChart from "@/components/wrappers/apexCharts/apexChart.vue";
import moment from "moment";

export default {
  props: {
    data: {
      type: Array,
      default: null,
    },
    rawData: {
      type: Array,
      default: null,
    },
    upperLimit: {
      type: [Number, String],
      default: null,
    },
    lowerLimit: {
      type: [Number, String],
      default: null,
    },
  },
  components: { apexChart },
  computed: {
    options: function () {
      return {
        chart: {
          id: "db",
          group: "test",
          events: {
            markerClick: (
              event,
              chartContext,
              { seriesIndex, dataPointIndex, config }
            ) => {
              // console.log(seriesIndex, chartContext, dataPointIndex, event);
              // this.$emit("clicked", dataPointIndex);
              // console.log(this);
              let idList = [];

              this.data.forEach((scan) => {
                idList.push(scan[dataPointIndex].raw);
              });

              let index = this.rawData.findIndex((val) =>
                idList.includes(val.raw)
              );
            },
            mounted: (chartContext, config) => {
              this.$q.loading.hide();
              this.updateLowerUperLimits();
            },
          },
          toolbar: {
            show: false,
          },
          animations: {
            enabled: true,
          },
          type: "area",
          stacked: false,
          zoom: {
            type: "x",
            enabled: false,
            autoScaleYaxis: false,
          },
        },
        stroke: {
          width: 1.5,
        },
        colors: ["#1b5e20", "#e91e63", "#1a237e"],
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          colors: undefined,
          strokeColors: "#fff",
          strokeWidth: 2,
          strokeOpacity: 0.9,
          strokeDashArray: 0,
          fillOpacity: 1,
          discrete: [],
          shape: "circle",
          radius: 2,
          offsetX: 0,
          offsetY: 0,
          onClick: undefined,
          onDblClick: undefined,
          showNullDataPoints: true,
          hover: {
            size: undefined,
            sizeOffset: 3,
          },
        },
        legend: {
          show: false,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 90, 100],
          },
        },
        yaxis: {
          labels: {
            show: true,
            formatter: function (val) {
              return `${Math.round(val + Number.EPSILON)}`;
            },
          },
          title: {},
        },
        xaxis: {
          crosshairs: {
            show: true,
          },
          tooltip: {
            enabled: false,
          },
          labels: {
            show: true,
          },
          type: "number",
        },
        annotations: {
          yaxis: [
            {
              id: "lower",
            },
            {
              id: "mid",
            },
            {
              id: "upper",
            },
          ],
        },
        tooltip: {
          shared: true,
          y: {
            formatter: function (val) {
              return `${val}`;
            },
          },
        },
      };
    },
  },
  watch: {
    upperLimit() {
      this.updateLowerUperLimits();
    },
    lowerLimit() {
      this.updateLowerUperLimits();
    },
    data() {
      let series = [];
      this.data.forEach((scan) => {
        series.push(this.calculateSeriesSingle(scan));
      });
      this.$refs.chart[0].updateSeries(series, true);
    },
  },
  data: () => ({
    apexChartColors: ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0"],
    ready: false,
    // Chart Stuff
    charts: [
      {
        series: [
          {
            name: "Moisture Reading",
            data: [],
          },
        ],
      },
    ],
  }),

  mounted() {
    this.calculateSeries();
    this.updateLowerUperLimits();
  },
  methods: {
    calculateSeries() {
      // Moisture Profile Survey
      // this.data.forEach((survey) => {
      //   survey.scans.forEach((scan) => {
      //     let seriesObj = this.calculateSeriesSingle(scan, survey.time);
      //     if (depths.includes(scan.depth)) {
      //       let index = charts.findIndex(function (chart) {
      //         return chart.depth === scan.depth;
      //       });
      //       charts[index].series.push(seriesObj);
      //     } else {
      //       depths.push(scan.depth);
      //       charts.push({
      //         depth: scan.depth,
      //         depthLabel:
      //           survey.type != "Single Depth Moisture Survey"
      //             ? `${scan.depth}-${scan.depth + survey.depthInterval}mm`
      //             : ``,
      //         series: [seriesObj],
      //       });
      //     }
      //   });
      // });

      let charts = [];
      let series = [];
      this.data.forEach((scan) => {
        series.push(this.calculateSeriesSingle(scan));
      });

      charts.push({
        depth: 0,
        depthLabel: ``,
        series: series,
      });

      this.charts = charts;
      // this.charts = [charts[0], charts[1]];
    },
    calculateSeriesSingle(scan) {
      let series = {
        name: "",
        data: [],
      };

      for (let i = 0; i < scan.length; i++) {
        let value = ((parseFloat(scan[i].value) + Number.EPSILON) * 100) / 100;
        series.data.push(value.toFixed(2));
      }

      return series;
    },
    zoom(min, max) {
      this.$refs["chart"][0].zoom(min, max);
    },
    dataPointSelection(index) {
      for (let i = 0; i < this.charts.length; i++) {
        this.$refs["chart"][i].dataPointSelection(index + 1);
      }
    },
    updateLowerUperLimits() {
      for (let i = 0; i < this.charts.length; i++) {
        this.$refs["chart"][i].updateLowerUperLimits({
          lower: this.lowerLimit,
          upper: this.upperLimit,
        });
      }
    },
  },
};
</script>

<style>
.apexcharts-xaxis {
  opacity: 0;
}
</style>
